import React, { Children, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import VirtualScrollChild from './VirtualScrollChild'

/**
 * https://github.com/alvinnguyen116/Virtual-Scroll-Component
 * A wrapper component for implementing virtual scroll
 * and infinite scroll. Each row is displayed with a static
 * height container. When the last child is in view, a "last
 * row" handler gets called.
 */
export default function VirtualScroll (props) {
  const { rowHeight, onLastRow, className } = props
  const [lastRowRef, lastRowInView] = useInView()

  // if last row is in view, call the last row handler
  useEffect(() => {
    if (lastRowInView) onLastRow?.()
  }, [lastRowInView])

  const localRows = Children.toArray(props.children)
  const renderRows = () => {
    const anchor = props.anchor
    return localRows.map((child, i) => {
      if (i === localRows.length - 1) {
        return (
          <VirtualScrollChild
            ref={lastRowRef}
            key={i}
            height={rowHeight}
            rootMargin={props.rootMargin}
            anchor={anchor?.(i)}
          >
            {child}
          </VirtualScrollChild>
        )
      }
      return (
        <VirtualScrollChild
          key={i}
          height={rowHeight}
          rootMargin={props.rootMargin}
          anchor={anchor?.(i)}
        >
          {child}
        </VirtualScrollChild>
      )
    })
  }

  return (
    <div
      className={
        className
          ? `virtual-scroll-container ${className}`
          : 'virtual-scroll-container'
      }
    >
      {renderRows()}
    </div>
  )
}
